import { render } from "./ConfigElement.vue?vue&type=template&id=72add844&scoped=true"
import script from "./ConfigElement.vue?vue&type=script&lang=js"
export * from "./ConfigElement.vue?vue&type=script&lang=js"

import "./ConfigElement.vue?vue&type=style&index=0&id=72add844&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72add844"]])

export default __exports__